
import React from 'react';
import Button from '../../../components/base/Button';
import { appStoreUrlHomeHeroCta, googlePlayUrlHomeHeroCta } from '@/utils/appStoreUtm';

export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden max-md:min-h-0 max-md:items-start max-md:pt-16 max-md:pb-8"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.3)), url('/images/hero-bg-001.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center max-md:gap-4">
          <div className="text-left pt-4 sm:pt-0">
            <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              旅をもっと<br />
              <span className="bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] bg-clip-text text-transparent">
                自由に
              </span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-4 sm:mb-6 md:mb-8 leading-relaxed max-w-2xl">
              AIでプランニング
            </p>
            <p className="text-base sm:text-lg text-white/80 mb-4 sm:mb-8 md:mb-10 max-w-2xl leading-relaxed">
              あなたの理想の旅行プランを簡単に作成。友達と共有して、思い出に残る旅を実現しよう。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-4 md:mb-8">
              <a href={appStoreUrlHomeHeroCta()} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto sm:shrink-0">
                <Button size="lg" className="flex items-center justify-center w-full">
                  <i className="ri-apple-fill mr-3 text-xl"></i>
                  App Storeでダウンロード
                </Button>
              </a>
              <a
                href={googlePlayUrlHomeHeroCta()}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto sm:shrink-0"
              >
                <Button
                  size="lg"
                  variant="outline"
                  className="flex items-center justify-center w-full border-white/80 bg-white/10 text-white hover:bg-white/20 hover:text-white"
                >
                  <i className="ri-google-play-fill mr-3 shrink-0 text-xl" aria-hidden />
                  Google Playでダウンロード
                </Button>
              </a>
            </div>
            
            {/* 無料ダウンロードテキストを復活 */}
            <div className="flex items-center space-x-6 text-white/70">
              <div className="flex items-center">
                <i className="ri-time-line mr-2"></i>
                <span className="text-sm font-medium">無料ダウンロード</span>
              </div>
            </div>
          </div>
          
          {/* Right Side - App Screenshots */}
          <div className="relative mt-4 md:mt-6 lg:mt-0">
            {/* App Screenshots Container */}
            <div className="relative flex items-center justify-center">
              {/* Background decorative elements */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#02D0F0]/10 to-[#07DBCA]/10 rounded-3xl blur-3xl transform rotate-6"></div>
              <div className="absolute inset-0 bg-gradient-to-tl from-[#07DBCA]/10 to-[#02D0F0]/10 rounded-3xl blur-2xl transform -rotate-3"></div>
              
              {/* Screenshots with improved layout */}
              <div className="relative flex items-end space-x-3 sm:space-x-4 lg:space-x-6 lg:ml-8">
                {/* First App Screenshot - Main */}
                <div className="relative transform hover:scale-105 transition-transform duration-300">
                  <div className="absolute -inset-2 sm:-inset-3 lg:-inset-4 bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] rounded-3xl blur-lg opacity-30"></div>
                  <img 
                    src="/images/7e439a3d8edc4cc7e915befd59d2628b.png"
                    alt="SOCIAL TRIPアプリ画面1"
                    className="relative w-32 sm:w-40 md:w-48 lg:w-56 h-auto rounded-3xl shadow-2xl z-10"
                  />
                </div>
                
                {/* Second App Screenshot - Secondary */}
                <div className="relative transform translate-y-4 sm:translate-y-6 lg:translate-y-8 hover:scale-105 transition-transform duration-300 hidden sm:block">
                  <div className="absolute -inset-2 sm:-inset-3 bg-gradient-to-r from-[#07DBCA] to-[#02D0F0] rounded-3xl blur-lg opacity-25"></div>
                  <img 
                    src="/images/253c131471e2180cf6d5101bb77ecbbd.jpg"
                    alt="SOCIAL TRIPアプリ画面2"
                    className="relative w-28 sm:w-36 md:w-40 lg:w-48 h-auto rounded-3xl shadow-xl z-10"
                  />
                </div>
              </div>
              
              {/* Floating elements */}
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
